/*
 * <pb-rail-nav for="ID-do-trilho">: setas anterior/próximo para um .pb-rail com rolagem horizontal.
 * Rola um "passo" (largura de um item + gap) e desabilita as setas nas pontas.
 */
if (!customElements.get('pb-rail-nav')) {
  customElements.define(
    'pb-rail-nav',
    class PbRailNav extends HTMLElement {
      connectedCallback() {
        this.rail = document.getElementById(this.getAttribute('for'));
        if (!this.rail) return;
        this.prev = this.querySelector('[data-dir="prev"]');
        this.next = this.querySelector('[data-dir="next"]');
        this.update = this.update.bind(this);
        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));
        this.rail.addEventListener('scroll', this.update, { passive: true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.rail);
        this.update();
      }

      disconnectedCallback() {
        this.rail?.removeEventListener('scroll', this.update);
        this.resizeObserver?.disconnect();
      }

      step() {
        const item = this.rail.firstElementChild;
        if (!item) return this.rail.clientWidth;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      go(direction) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollBy({ left: direction * this.step(), behavior: reduce ? 'auto' : 'smooth' });
      }

      update() {
        const max = this.rail.scrollWidth - this.rail.clientWidth - 2;
        const scrollable = max > 0;
        this.hidden = !scrollable;
        if (this.prev) this.prev.disabled = this.rail.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.rail.scrollLeft >= max;
      }
    }
  );
}
